import { getBaseURL, get, post, deletes } from "./request";

const HttpManager = {
  // 获取图片信息
  attachImageUrl: (url) => `${getBaseURL()}${url}`,
  // =======================> 用户 API 完成
  // 登录
  signIn: ({username,password}) => post(`user/login`, {username,password}),
  // 注册
  SignUp: ({username,password,sex,phoneNum,email,birth,introduction,location}) => post(`user/add`, {username,password,sex,phoneNum,email,birth,introduction,location}),
  // 删除用户
  deleteUser: (id) => get(`user/delete?id=${id}`),
  // 更新用户信息
  updateUserMsg: ({id,username,sex,phoneNum,email,birth,introduction,location,avator}) => post(`user/update`, {id,username,sex,phoneNum,email,birth,introduction,location,avator}),
  updateUserPassword: ({id,username,oldPassword,password}) => post(`user/updatePassword`, {id,username,oldPassword,password}),
  // 返回指定ID的用户
  getUserOfId: (id) => get(`user/detail?id=${id}`),
  // 更新用户头像
  uploadUrl: (userId) => `${getBaseURL()}/user/avatar/update?id=${userId}`,
  // 获取用户信息
  userInfo: () => get(`user/info`),

  // =======================> 微博 API 完成
  // 获取微博Oauth2.0的url
  getWeiboUrl: () => get(`weibo/oauth2.0/url`),
  // 获取微博授权用户信息
  weiboLogin: (code) => get(`/weibo/oauth2.0/login?code=${code}`),

  // =======================> 歌单 API 完成
  // 获取全部歌单
  getAllSongList: () => get("allSongList"),
  // 获取公共歌单
  getPublicSongList: () => get("publicSongList"),
  // 获取指定歌单ID的歌单
  getSongList: (id) => get(`songList?id=${id}`),
  // 获取歌单类型
  getSongListOfStyle: (style) => get(`songList/style/detail?style=${style}`),
  // 返回标题包含文字的歌单
  getSongListOfLikeTitle: (keywords) => get(`songList/likeTitle/detail?title=${keywords}`),
  // 返回歌单里指定歌单ID的歌曲
  getListSongOfSongId: (songListId) => get(`listSong/detail?songListId=${songListId}`),
  // 获取登陆用户的歌单
  getUserSongList: (userId) => get(`userSongList?userId=${userId}`),
  // 添加歌单
  setSongList: ({title, introduction, style, pic, userId, isPrivate}) => post(`songList/add`, {title, introduction, style, pic, userId, isPrivate}),
  // 删除歌单
  deleteSongList: (id) => get(`songList/delete?id=${id}`),
  // 更新歌单信息
  updateSongListMsg: ({id, title, introduction, style, isPrivate}) => post(`songList/update`, {id, title, introduction, style, isPrivate}),
  // =======================> 歌手 API  完成
  // 返回所有歌手
  getAllSinger: () => get("singer"),
  // 通过性别对歌手分类
  getSingerOfSex: (sex) => get(`singer/sex/detail?sex=${sex}`),

  // =======================> 收藏 API 完成
  // 返回的指定用户ID的收藏列表
  getCollectionOfUser: (userId) => get(`collection/detail?userId=${userId}`),
  // 添加收藏的歌曲 type: 0 代表歌曲， 1 代表歌单
  setCollection: ({userId,type,songId}) => post(`collection/add`,{userId,type,songId}),

  deleteSong: (userId, songId) => deletes(`collection/delete?userId=${userId}&songId=${songId}`),

  isCollection: ({userId, type, songId}) => post(`collection/status`, {userId, type, songId}),

  // =======================> 评分 API 完成
  // 提交评分
  setRank: ({songListId,consumerId,score}) => post(`rankList/add`, {songListId,consumerId,score}),
  // 获取指定歌单的评分
  getRankOfSongListId: (songListId) => get(`rankList?songListId=${songListId}`),
  // 获取指定用户的歌单评分
  getUserRank: (consumerId, songListId) => get(`/rankList/user?consumerId=${consumerId}&songListId=${songListId}`),

  // =======================> 评论 API 完成
  // 添加评论
  setComment: ({userId,content,songId,songListId,nowType}) => post(`comment/add`, {userId,content,songId,songListId,nowType}),
  // 删除评论
  deleteComment: (id) => get(`comment/delete?id=${id}`),
  // 点赞
  setSupport: ({id,up}) => post(`comment/like`, {id,up}),
  // 返回所有评论
  getAllComment: (type, id) => {
    let url = "";
    if (type === 1) {
      url = `comment/songList/detail?songListId=${id}`;
    } else if (type === 0) {
      url = `comment/song/detail?songId=${id}`;
    }
    return get(url);
  },

  // =======================> 歌曲 API
  // 返回指定歌曲ID的歌曲
  getSongOfId: (id) => get(`song/detail?id=${id}`),
  // 返回指定歌手ID的歌曲
  getSongOfSingerId: (id) => get(`song/singer/detail?singerId=${id}`),
  // 返回指定歌手名的歌曲
  getSongOfSingerName: (keywords) => get(`song/singerName/detail?name=${keywords}`),
  // 下载音乐
  downloadMusic: (url) => get(url, { responseType: "blob" }),

  //======================> 点赞api的优化 避免有些是重复的点赞！新增数据表了得

  testAlreadySupport:({commentId,userId}) => post(`userSupport/test`, {commentId,userId}),

  deleteUserSupport:({commentId,userId}) => post(`userSupport/delete`, {commentId,userId}),

  insertUserSupport:({commentId,userId}) => post(`userSupport/insert`, {commentId,userId}),

  //获取所有的海报
  getBannerList: () => get("banner/getAllBanner"),

  // =======================> 歌单歌曲 API 完成
  // 给歌单添加歌曲
  setListSong: ({songId,songListId}) => post(`listSong/add`, {songId,songListId}),
  // 删除指定歌单里的歌曲
  deleteSongOfSongList: (songId, songListId) => deletes(`listSong/songList/delete?songId=${songId}&songListId=${songListId}`),
};



export { HttpManager };
